import { bannerPreviewSchema } from "../schemas";
import {
  makeAnyKeySelector,
  makeCollectionSelector,
  makeAnyKeyCollectionSelector,
  makeFetchStatusSelector,
} from "./collections";

export const DEFAULT_COLLECTION = "index";

export function makeViewAnyKeySelector(key, collection) {
  return makeAnyKeySelector(key, collection, bannerPreviewSchema);
}

export function makeBannerPreviewsSelector(collection = DEFAULT_COLLECTION) {
  return makeCollectionSelector(collection, bannerPreviewSchema);
}

export function makeBannerPreviewsAnyKeySelector(key, collection = DEFAULT_COLLECTION) {
  return makeAnyKeyCollectionSelector(key, collection, bannerPreviewSchema);
}

export function makeBannerPreviewsFetchStatusSelector(collection = DEFAULT_COLLECTION) {
  return makeFetchStatusSelector(collection, bannerPreviewSchema);
}